module.exports = __webpack_public_path__ + "static/media/Yuri.9ab4384a.png";